import type { IPathBaseParam } from "./path";
import type { ICourseStatsResponse } from "./types";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";

const getApis = createGetApi<
  IApiResponse<ICourseStatsResponse>,
  IPathBaseParam,
  object
>("courses.stats.users.me");

export const me = {
  ...getApis,
};
